// assets.js
export const mapMarkers = [{
	type: 'toilet',
	iconPath: '/static/maps/toilet.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			id: 't01',
			lon: 112.18013034696469,
			lat: 31.010805921951974,
			name: '厕所'
		},
		{
			id: 't02',
			lon: 112.18011854306064,
			lat: 31.015120929791188,
			name: '厕所'
		},
		{
			id: 't03',
			lon: 112.17875993793155,
			lat: 31.01284099117212,
			name: '厕所'
		}, , {
			id: 't04',
			lon: 112.1784617919775,
			lat: 31.01095050588345,
			name: '厕所'
		}
	]
}, {
	type: 'parking',
	iconPath: '/static/maps/parking.png',
	width: 30,
	height: 20,
	//joinCluster: true, // 指定了该参数才会参与聚合
	label: {
		width: 50,
		height: 30,
		borderWidth: 1,
		borderRadius: 10,
		bgColor: '#ffffff',
	},
	pois: [{
			id: 'p01',
			lon: 112.18232749099889,
			lat: 31.012513918042853,
			name: '厕所'
		},
		{
			id: 'p02',
			lon: 112.17975609546716,
			lat: 31.009976807156193,
			name: '厕所'
		},
		{
			id: 'p03',
			lon: 112.17287823747893,
			lat: 31.01241671437313,
			name: '厕所'
		}, , {
			id: 'p04',
			lon: 112.18190850514031,
			lat: 31.005199383798733,
			name: '厕所'
		}
	]
}, ]